var render, staticRenderFns
import script from "./HKLInputNumber.vue?vue&type=script&lang=js&"
export * from "./HKLInputNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76f8011a')) {
      api.createRecord('76f8011a', component.options)
    } else {
      api.reload('76f8011a', component.options)
    }
    
  }
}
component.options.__file = "src/modules/ccd/tenancy/greenOperation/components/HKLInputNumber.vue"
export default component.exports